/**
 * Initial field state.
 */
export const FIELD_STATE_IDLE = 'IDLE';

/**
 * Field is focused. It may be the case that this value isn't accurately reflected in the store when user focuses from one iframe to the other.
 * It happens because the focus event is not bubbled to the parent and there is simply no way to know the focus has moved.
 * We kind of workaround it by checking the active element on blur (with a slight delay, because iframe's parent isn't getting "active" straight away).
 */
export const FIELD_STATE_FOCUSED = 'FOCUSED';

/**
 * Field's submission is in progress.
 */
export const FIELD_STATE_PENDING = 'PENDING';

/**
 * Field's value is stored.
 */
export const FIELD_STATE_STORED = 'STORED';

/**
 * There was an issue processing the field's value.
 */
export const FIELD_STATE_FAILED = 'FAILED';

/**
 * The field's value was not processed in time.
 */
export const FIELD_STATE_TIMED_OUT = 'TIMED_OUT';
